import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    backgroundColor: 'common.lightBackgroundColor',
  },
  subContainer: {
    paddingX: '20px',
    paddingY: '24px',
  },
  promoLabel: {
    fontSize: 14,
    backgroundColor: 'secondary.main',
    px: 2,
    py: 1,
    minWidth: 0,
    color: 'common.counterRed',
    borderRadius: 10,
    fontWeight: '500',
    alignSelf: 'flex-start',
  },
  buttonContainer: {
    gap: '15px',
    flex: 1,
    position: 'sticky',
    bottom: 0,
    width: '100%',
    paddingY: '16px',
    backgroundColor: 'common.lightBackgroundColor',
    justifyContent: 'flex-end',
    boxShadow: '0px -2px 4px 0px #0000000A',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2,1fr)',
    columnGap: '10px',
    mt: 1,
  },
  cardContainer: {
    backgroundColor: 'secondary.main',
  },
  footerContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  footerLabel: {
    fontSize: 12,
    color: 'common.grey850',
  },
  footerValue: {
    fontSize: 14,
    color: 'common.grey850',
    fontWeight: '500',
  },
  fieldContainer: {
    display: 'flex',
    gap: '23px',
    mt: '24px',
  },
  labelStyle: {
    wordWrap: 'normal',
    whiteSpace: 'normal',
    fontSize: 12,
    textAlign: 'left',
    minWidth: '80px',
  },
  stackContainer: {
    mb: '30px',
  },
  chips: {
    display: 'flex',
    backgroundColor: 'secondary.main',
    p: '16px',
    borderRadius: '8px',
    mb: '24px',
    alignItems: 'center',
  },
  chipContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  chipLabel: {
    maxWidth: 80,
    mr: '8px',
  },
  closeButton: {
    mr: '40px',
    width: 202,
  },
  topCard: {
    mt: 1.5,
  },
  topField: {
    mt: -2,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
